import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import api from "./api/api";

function CustomerFidelityPopup({ customer, onClose, onRefresh }) {
	const { shops } = useContext(AppContext);
	const [transactions, setTransactions] = useState([]);
	const [loading, setLoading] = useState(true);
	const [showForm, setShowForm] = useState(false);
	const [formMode, setFormMode] = useState("accredita");
	const [description, setDescription] = useState("");
	const [points, setPoints] = useState("");
	const [shopId, setShopId] = useState("");
	const [orderId, setOrderId] = useState("");
	const [saving, setSaving] = useState(false);

	const balance = transactions.reduce((sum, t) => sum + parseInt(t.points || 0), 0);
	const initials =
		((customer.surname || "")[0] || "").toUpperCase() +
		((customer.name || "")[0] || "").toUpperCase();

	useEffect(() => {
		loadTransactions();
	}, []);

	async function loadTransactions() {
		setLoading(true);
		const res = await api.postProtected("/points_transactions/list/", {
			src: [
				{ name: "customer_id", value: customer.id, compare: "equal" },
				{ name: "expired", value: 0, compare: "equal" },
			],
			orderby: "date_insert",
		});
		setLoading(false);
		if (res?.rows) setTransactions(res.rows);
	}

	async function handleDelete(id) {
		if (!window.confirm("Eliminare questa transazione?")) return;
		await api.postProtected("/points_transactions/delete/" + id + "/");
		loadTransactions();
		if (onRefresh) onRefresh();
	}

	async function handleSave(e) {
		e.preventDefault();
		if (!description.trim() || !points) return;
		setSaving(true);
		const pts = formMode === "accredita" ? parseInt(points) : -parseInt(points);
		await api.postProtected("/points_transactions/add/", {
			customer_id: customer.id,
			name: description.trim(),
			points: pts,
			shop_id: shopId || null,
			order_id: orderId || null,
		});
		setSaving(false);
		setShowForm(false);
		setDescription("");
		setPoints("");
		setShopId("");
		setOrderId("");
		loadTransactions();
		if (onRefresh) onRefresh();
	}

	return (
		<div className="ctp-wrap">
			<div className="ctp-header">
				<div className="ctp-avatar">{initials}</div>
				<div className="ctp-info">
					<div className="ctp-name">
						{customer.name} {customer.surname}
					</div>
					<div className="ctp-phone">
						{customer.area_code}
						{customer.mobile}
					</div>
				</div>
				<div className="ctp-balance">
					<div className="ctp-balance-label">PUNTI</div>
					<div className="ctp-balance-value ctp-balance-points">{balance}</div>
				</div>
			</div>

			{!showForm ? (
				<>
					<div className="ctp-list-header">
						<div className="ctp-list-title">Storico punti fidelity</div>
						<button className="ctp-insert-btn" onClick={() => setShowForm(true)}>
							+ Inserisci
						</button>
					</div>

					{loading && <div className="ctp-empty">Caricamento...</div>}
					{!loading && transactions.length === 0 && (
						<div className="ctp-empty">Nessuna transazione</div>
					)}
					{!loading && transactions.length > 0 && (
						<div className="ctp-table-wrap">
							<table className="ctp-table">
								<thead>
									<tr>
										<th>DATA</th>
										<th>DESCRIZIONE</th>
										<th>NEGOZIO</th>
										<th>ORDINE</th>
										<th>PUNTI</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{transactions.map((t) => (
										<tr key={t.id}>
											<td className="ctp-td-date">{t.date_insert}</td>
											<td>{t.name}</td>
											<td>{t.shop?.name || "—"}</td>
											<td>{t.order_id || "—"}</td>
											<td
												className={
													"ctp-td-amount " +
													(parseInt(t.points) >= 0 ? "ctp-positive" : "ctp-negative")
												}
											>
												{parseInt(t.points) >= 0 ? "+ " : ""}
												{t.points}
											</td>
											<td>
												<button
													className="ctp-delete-btn"
													onClick={() => handleDelete(t.id)}
													title="Elimina"
												>
													🗑
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</>
			) : (
				<form className="ctp-form" onSubmit={handleSave}>
					<div className="ctp-form-tabs">
						<button
							type="button"
							className={"ctp-tab " + (formMode === "accredita" ? "ctp-tab-active" : "")}
							onClick={() => setFormMode("accredita")}
						>
							+ Accredita punti
						</button>
						<button
							type="button"
							className={"ctp-tab " + (formMode === "riscatta" ? "ctp-tab-active" : "")}
							onClick={() => setFormMode("riscatta")}
						>
							% Riscatta punti
						</button>
					</div>

					<div className="ctp-form-group">
						<label>Descrizione*</label>
						<input
							type="text"
							placeholder="es. Punti guadagnati, Buono sconto..."
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							required
							autoFocus
						/>
					</div>

					<div className="ctp-form-row">
						<div className="ctp-form-group">
							<label>Punti*</label>
							<input
								type="number"
								min="1"
								step="1"
								placeholder="0"
								value={points}
								onChange={(e) => setPoints(e.target.value)}
								required
							/>
						</div>
						<div className="ctp-form-group">
							<label>Negozio</label>
							<select value={shopId} onChange={(e) => setShopId(e.target.value)}>
								<option value="">— Seleziona negozio —</option>
								{Array.isArray(shops) && shops.map((s) => (
									<option key={s.id} value={s.id}>{s.name}</option>
								))}
							</select>
						</div>
					</div>

					<div className="ctp-form-group">
						<label>Ordine</label>
						<input
							type="text"
							placeholder="N° ordine (facoltativo)"
							value={orderId}
							onChange={(e) => setOrderId(e.target.value)}
						/>
					</div>

					<div className="ctp-form-actions">
						<button
							type="button"
							className="ctp-btn-cancel"
							onClick={() => {
								setShowForm(false);
								setDescription("");
								setPoints("");
								setShopId("");
								setOrderId("");
							}}
						>
							Annulla
						</button>
						<button type="submit" className="ctp-btn-save" disabled={saving}>
							Salva
						</button>
					</div>
				</form>
			)}
		</div>
	);
}

export default CustomerFidelityPopup;
